<template>
    <!-- contents -->
    <div id="contents">
        <div v-if="viewName == 'MC'" class="contents_wrap">
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{$t('TITLE.SEARCH.RESULTS')}}</h2>
            <div class="srchTop_wrap srch_result mb-20">
                <article class="srch_basic clear">
                    <dl class="dl_search w100p"><!-- 200525수정(검색필드가 하나일때 w100p 클래스 추가) -->
                        <dd class="clearable" data-input-type="input">
                            <input type="text" class="text_input w100p" v-model="modelCode" ref="modelCd" @keyup="onAutoCmpl" @keyup.enter.stop="onSearch(1)"
                                :placeholder="placeHolder" maxLength="20">
                            <i class="clearable_clear">X</i>
                        </dd>
                        <dd class="btn"><a href="javascript:" @click="onSearch(1)" class="btn_srch">{{$t('BUTTON.GLOBAL.SEARCH')}}</a></dd>
                        <dd v-if="searchMode == '1'" class="auto">
                            <!-- search autocomplete -->
                            <article class="srch_more">
                                <dl class="srch_autocomplete">
                                    <dd>
                                        <ul class="scroll">
                                            <li v-for="model in autoCompletes" :key="model.ID" :class="{active: model.ID == modelCode}">
                                                <a href="JavaScript:" @click="modelCode = model.ID; searchMode = '0'">{{model.LABEL}}</a>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                            </article>
                        </dd>
                    </dl>
                </article>
            </div>

            <!-- 결과 영역 -->
            <div class="result_wrap">
                <p class="refine"><em>{{$t('TITLE.SEARCH.RESULT.FOR')}}</em> '{{modelCode}}'</p>
                <!-- 1. Quick Downloads -->
                <section data-type="quick" class="active"><!-- 활성화시 active 클래스 -->
                    <div class="result_title">
                        <em>{{$t('TITLE.SEARCH.QUICK.DOWNLOAD')}}</em>
                    </div>

                    <div class="result_con">
                        <!-- Quick Downloads - PC -->
                        <div v-if="quickDownloads.length > 0" class="table_modul table_scroll pc_only">
                            <table class="data_table_ty2">
                                <colgroup>
                                    <col width="155px">
                                    <col width="140px" v-for="col in columns" :key="col.boardId">
                                    <col width="140px">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>{{$t('FIELD.SEARCH.MODELS')}}</th>
                                        <th v-for="col in columns" :key="col.boardId" align="center">{{col.headerNm}}</th>
                                        <th>{{$t('FIELD.SEARCH.BOM')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="data in quickDownloads" :key="data.BMODEL_ID">
                                        <td class="text_center">
                                            <a href="JavaScript:"><em class="txt_point" @click="clickQcModel(data.BMODEL_ID)">{{data.BMODEL_ID}}</em></a>
                                        </td>
                                        <td class="text_center" v-for="sub in data.subValues" :key="sub.ID">
                                            <a v-if="sub.headId == 'CNT_EXPVP'" href="JavaScript:" @click="viewAttachFiles($event, data)">
                                                <em class="txt_point">{{sub.cntSum}}</em>
                                            </a>
                                            <a v-if="sub.headId != 'CNT_EXPVP' && sub.cntSum > 0" href="JavaScript:" @click="fileDownload(sub.nIndex, data)">
                                                <em class="txt_point">{{sub.cntSum}}</em>
                                            </a>
                                            <span v-if="sub.headId != 'CNT_EXPVP' && sub.cntSum == 0">{{sub.cntSum}}</span>
                                        </td>
                                        <td class="text_center">
                                            <a href="JavaScript:" class="ico_attach" @click="popupBomOpen(data)"><span class="sr_only">attach</span></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- //Quick Downloads - PC -->

                        <!-- Quick Downloads - Tablet/Mobile -->
                        <div v-if="quickDownloads.length > 0" class="table_modul tabmobile_only">
                            <table class="data_table_ty2">
                                <colgroup>
                                    <col width="70%">
                                    <col width="30%">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th class="select_th" colspan="2">
                                            <select class="slt_white w100p" v-model="selModelCd" @change="changeQdnModel()">
                                                <option v-for="model in quickDownloads" :key="model.BMODEL_ID" :value="model.BMODEL_ID">{{model.BMODEL_ID}}</option>
                                            </select>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="sub in selModels" :key="sub.ID">
                                        <td>{{sub.headNm}}</td>
                                        <td class="text_center">
                                            <a v-if="sub.headId == 'CNT_EXPVP'" href="JavaScript:" @click="viewAttachFiles($event, {BMODEL_ID: selModelCd})">
                                                <em class="txt_point">{{sub.cntSum}}</em>
                                            </a>
                                            <a v-if="sub.headId != 'CNT_EXPVP' && sub.cntSum > 0" href="JavaScript:" @click="fileDownload(sub.nIndex, {BMODEL_ID: selModelCd})">
                                                <em class="txt_point">{{sub.cntSum}}</em>
                                            </a>
                                            <span v-if="sub.headId != 'CNT_EXPVP' && sub.cntSum == 0">{{sub.cntSum}}</span>
                                        </td>
                                    </tr>
                                    <tr v-if="selModelCd">
                                        <td>{{$t('FIELD.SEARCH.BOM')}}</td>
                                        <td class="text_center">
                                            <a href="JavaScript:" class="ico_attach" @click="popupBomOpen({BMODEL_ID: selModelCd})"><span class="sr_only">attach</span></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- //Quick Downloads - Tablet/Mobile -->

                        <div class="table_modul gridDown_wrap" v-if="qcdnAttachFiles.length > 0">
                            <div class="gridtop_wrap">
                                <em class="txt_info">{{$t('MESSAGE.SEARCH.REQ.EXPLORER')}}</em>
                                <div class="btn_wrap">
                                    <a href="http://skp.samsungcsportal.com/basis/page/Dejavu_Viewer.zip" class="btn_white" title=""><i class="ico_down"></i>Deju Vu</a>
                                    <a href="http://skp.samsungcsportal.com/basis/page/isoview7.cab" class="btn_white" title=""><i class="ico_down"></i>iso View</a>
                                </div>
                            </div>
                            <table class="data_table_ty2">
                                <colgroup>
                                    <col width="25%">
                                    <col width="20%">
                                    <col width="25%">
                                    <col width="*">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>{{$t('FIELD.GLOBAL.MODEL')}}</th>
                                        <th>{{$t('FIELD.GLOBAL.VERSION')}}</th>
                                        <th class="pc_only">{{$t('FIELD.SEARCH.WEB.VIEW')}}</th>
                                        <th>{{$t('FIELD.SEARCH.PDF')}}</th>
                                    </tr>
                                </thead>
                                <tbody class="text_center">
                                    <tr v-for="file in qcdnAttachFiles" :key="file.VERSION + file.BOM_VERSION">
                                        <td>{{file.MODEL_CD}}</td>
                                        <td>{{file.VERSION}}</td>
                                        <td class="pc_only">
                                            <a href="JavaScript:" @click="popupHtmlOpen(file)" v-if="file.BOM_FILE_NAME" class="txt_link">{{$t('BUTTON.SEARCH.CLICK')}}</a>
                                        </td>
                                        <td>
                                            <a :href="'http://downloadcenter.samsung.com/content/' + file.PDF_PATH" target="_blank" class="txt_link">{{file.PDF_FILE_NAME}}</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div v-if="quickDownloads && quickDownloads.length > 0" class="btn_wrap">
                            <a href="JavaScript:" class="btn_laodmore" @click="loadMoreSearch()">{{qcdnMoreMsg}} <em>(<i>{{quickDownloads.length}}</i>/{{qcdnTotalCount}})</em></a>
                        </div>
                        <ul v-if="qcdnTotalCount == 0" class="nodata_list">
                            <li>
                                <span>{{$t('MESSAGE.GLOBAL.NO.DATA')}}</span>
                            </li>
                        </ul>
                    </div>
                </section><!-- 1. End of Quick Downloads -->
            </div>
        </div> <!-- contents_wrap -->

        <div v-if="viewName == 'EM'" class="contents_wrap">
            <!-- contents_head -->
            <h2 class="pg_title">{{$t('TITLE.PRODUCT.INFO.EXPLODED.VIEW')}}</h2>
            <!-- //contents_head -->
            <!-- srchTop_wrap -->
            <div class="srchTop_wrap srch_result mb-20">
                <article class="srch_basic clear">
                    <dl class="dl_search w100p"><!-- 200525수정(검색필드가 하나일때 w100p 클래스 추가) -->
                        <dd class="clearable" data-input-type="input">
                            <input type="text" class="text_input w100p" v-model="modelCode" ref="modelCd" @keyup="onAutoCmpl" @keyup.enter.stop="onSearchExp(1)"
                                :placeholder="placeHolder" maxLength="20">
                            <i class="clearable_clear">X</i>
                        </dd>
                        <dd class="btn"><a href="javascript:" @click="onSearchExp(1)" class="btn_srch">{{$t('BUTTON.GLOBAL.SEARCH')}}</a></dd>
                        <dd v-if="searchMode == '1'" class="auto">
                            <!-- search autocomplete -->
                            <article class="srch_more">
                                <dl class="srch_autocomplete">
                                    <dd>
                                        <ul class="scroll">
                                            <li v-for="model in autoCompletes" :key="model.ID" :class="{active: model.ID == modelCode}">
                                                <a href="JavaScript:" @click="modelCode = model.ID">{{model.LABEL}}</a>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                            </article>
                        </dd>
                    </dl>
                </article>
            </div>

            <!-- Grid -->
            <div class="grid_wrap">
                <div class="grid_total">Total Count : <em>{{ resultCount | numberFormat }}</em></div>
                <toast-grid
                    :gridId="gridId"
                    :columns="columns"
                    :data="gridData"
                    :options="options"
                    :ref="gridId"
                    :key="gridKey"
                    :pageOptions="pageOptions"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div>
            <!-- gridDown_wrap -->
            <div v-if="selModelCd &&  qcdnAttachFiles.length > 0" class="gridDown_wrap">
                <div class="table_modul gridDown_wrap">
                    <div class="gridtop_wrap">
                        <em class="txt_info">{{$t('MESSAGE.SEARCH.REQ.EXPLORER')}}</em>
                        <div class="btn_wrap">
                            <a href="http://skp.samsungcsportal.com/basis/page/Dejavu_Viewer.zip" class="btn_white" title=""><i class="ico_down"></i>Deju Vu</a>
                            <a href="http://skp.samsungcsportal.com/basis/page/isoview7.cab" class="btn_white" title=""><i class="ico_down"></i>iso View</a>
                        </div>
                    </div>
                    <table class="data_table_ty2">
                        <colgroup>
                            <col width="25%">
                            <col width="20%">
                            <col width="25%">
                            <col width="*">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>{{$t('FIELD.GLOBAL.MODEL')}}</th>
                                <th>{{$t('FIELD.GLOBAL.VERSION')}}</th>
                                <th class="pc_only">{{$t('FIELD.SEARCH.WEB.VIEW')}}</th>
                                <th>{{$t('FIELD.SEARCH.PDF')}}</th>
                            </tr>
                        </thead>
                        <tbody class="text_center">
                            <tr v-for="file in qcdnAttachFiles" :key="file.VERSION">
                                <td>{{file.MODEL_CD}}</td>
                                <td>{{file.VERSION}}</td>
                                <td class="pc_only">
                                    <a href="JavaScript:" @click="popupHtmlOpen(file)" v-if="file.BOM_FILE_NAME" class="txt_link">{{$t('BUTTON.SEARCH.CLICK')}}</a>
                                </td>
                                <td>
                                    <a :href="'http://downloadcenter.samsung.com/content/' + file.PDF_PATH" target="_blank" class="txt_link">{{file.PDF_FILE_NAME}}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div> <!-- contents_wrap -->
    </div> <!-- contents -->
</template>

<script>
import Vue              from 'vue';
import axios            from 'axios';
import store            from '@/vuex/store';
import qs               from 'query-string';
import _                from 'lodash';
import $                from 'jquery';
import moment           from 'moment';
import { mapGetters }   from 'vuex';
import { SDLUtil }      from '@/utils';
import AttachFilePopup  from './AttachFilePopup';
import InnorixDownload  from '~c/InnorixDownload';
import ExpToastGrid     from '~c/ToastGrid';

export default {
    name: 'GspnModelSearch',
    props: {
//        params: {}
    },
    components: {
        'toast-grid'        : ExpToastGrid,
        'innorix-download'  : InnorixDownload
    },

    computed: {
        ...mapGetters({
            popupParams: 'getPopupParams'
        })
    },
    data() {
        return {
            isLoaded: 0,
            viewName: 'MC',
            params: {},
            startNum: 0,    // 시작순서
            pageSize: 10,    // 페이지당 갯수
            serverSize: 50, // 서버 페이지당 갯수
            sortBy: 'regdate',
            relResearch: 'N',
            placeHolder: SDLUtil.getMsgProp('FIELD.PLACEHOLDER.KNOWLEDGE.SEARCH'),
            searchMode: '0',
            modelCode: '',
            selModelCd: '',
            selModels: [],
            moreKey: '', // contcoll ID
            autoCompletes: [],
            recentModels: [],
            cursorIndex: -1,
            relatedSearchWords: [],
//            columns: [],
            quickDownloads: [],

            sympCode: '',
            sympDesc: '',
            sympTypeCode: '',

            toggle1: true,

            qcdnMoreMsg: SDLUtil.getMsgProp('BUTTON.SEARCH.LOAD.MORE'),
            qcdnPage : 1,
            qcdnAttachFiles: [],

            qcdnTotalCount: 0, // Quick Downloads 전체건수
            resultCount: 0,

            placeHolder: SDLUtil.getMsgProp('FIELD.PLACEHOLDER.KNOWLEDGE.SEARCH'),
            currentPage: 1,
            perPage: 3000, // parseInt(localStorage.getItem('listRows') || 10),
            gridId : 'gridExpModel',
            gridKey: 0,
            gridData :  [],
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'),
                    name: 'MODEL_CD',
                    align: 'center',
                    width: '200',
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.EXPVIEW.PROD.DESC'),
                    name: 'PROD_DESC',
                    align: 'center',
                    width: '200',
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.EXPVIEW.PLANT'),
                    name: 'PLANT',
                    align: 'center',
                    width: '200',
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('TITLE.PRODUCT.INFO.EXPLODED.VIEW'),
                    name: 'VIEW_CNT',
                    align: 'center',
                    width: '200',
                    sortable: true
                }
            ],            
            options: {
                scrollY: false,
                scrollX: false,
//                minBodyHeight: 80,
//                bodyHeight: 318,
                rowHeight: 25,
                // rowHeaders: ['checkbox'],
            },
            pageOptions: {
                useClient: true,
                perPage: 10, //parseInt(localStorage.getItem('listRows') || 10),
            },

            serviceType: 'common'
        };
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            userCorpCd: 'getCorpCd'
        }),
        getLoginNo()            { return this.loginNo || ''; },
        getUserCorpCd()         { return this.userCorpCd || ''; }
    },
    methods: {
        initReset() {
            this.dtcmPage    = 1;
            this.qcdnTotalCount = -1;
//            this.relatedSearchWords = [];
            this.quickDownloads  = [];
            this.qcdnLoadCount = 0;
            this.qcdnAttachFiles = [];
        },
        async saveRecentModel() {
            const url = `${SDLUtil.API_URL}/basis/search/saveRecentModel.skp`;
            const param = {searchKind: 'C', keyword : this.modelCode};
            return await axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                })
                .then(resp => {
//                    this.$refs.kword.focus(); // 자동완성 저장
                })
                .catch(err => {
                    console.log('Err.saveRecentModel ==> ', err);
                    SDLUtil.errorAlert(err);
                });
        },
        // 헤더 컬럼 세팅
        setColumnHeader(data, page) {
            this.columns = [];
            if (!data.header) {
                this.quickDownloads = [];
                return;
            }

            if (data.contentModels.rowData && data.contentModels.rowData.length > 0) {
            data.header.rowData.forEach(head => {
                let headId = 'CNT' + (head.CONTENT_VIEW_ORDER - 1);
                if (head.CONTENT_VIEW_ORDER == 999) {
                    headId = 'CNT_EXPVP';
                }
                let width = 90 + (head.MENU_NM.length * 2);
                let cols = {
                    headerId: headId
                  , boardId : head.BOARD_ID
                  , headerNm: head.MENU_NM
                };
                this.columns.push(cols);
            });
            }

            data.contentModels.rowData.forEach(data => {
                let newArr = [];
                this.columns.forEach((col, index) => {
                    let val = eval('data.CNT' + index);
                    if (col.headerId == 'CNT_EXPVP') {
                        val = 'WEB: ' + eval('data.CNT' + index) + ' / PDF: ' + data.CNT_EXPVP;
                    }
                    let colSum = {ID: 'CNT' + index, nIndex: index, cntSum: val, headId: col.headerId, headNm: col.headerNm};
                    newArr.push(colSum);
                });
                data.subValues = newArr;
            });

            if (page == 1) {
                this.quickDownloads = data.contentModels.rowData;
            } else { // > 1
                data.contentModels.rowData.forEach(adata => {
                    this.quickDownloads.push(adata);
                });
            }
            if (this.quickDownloads && this.quickDownloads.length > 0) {
                this.selModelCd = this.quickDownloads[0].BMODEL_ID; 
                this.selModels = this.quickDownloads[0].subValues;
            }
        },
        async onAutoComplete() {
            const param = { keyword: this.modelCode };
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/search/getAutoComplete.skp`, 
                    qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                })
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    this.autoCompletes = resp.data;
                    console.log('autoCompletes ======> ', resp.data);
                    this.$refs.modelCd.focus();
                })
                .catch(err => {
                    console.log('Err.onAutoComplete ======> ', err);
                    SDLUtil.errorAlert(err);
                });
        },
        onAutoCmpl(event) {
            if (event.key == 'Enter' || event.key == 'Escape') return;

            // 상하 화살표 키
            if (event.key == 'ArrowUp' || event.key == 'ArrowDown') { // 위 화살표
                if (event.key == 'ArrowUp') this.cursorIndex -= 1;
                if (event.key == 'ArrowDown') this.cursorIndex += 1;

                if (this.cursorIndex < 0) {
                    this.cursorIndex = this.autoCompletes.length - 1;
                }

                if (this.cursorIndex >= this.autoCompletes.length) this.cursorIndex = 0;
                if (this.autoCompletes.length > 0) this.modelCode = this.autoCompletes[this.cursorIndex].ID;

                return;
            }

            this.modelCode = this.modelCode.toUpperCase();

            if (this.modelCode.length > 2) { // 3자 이상이면...
                this.onAutoComplete();
                this.searchMode = '1';
            } else {
                this.searchMode = '0';
            }
        },
        getDataFromServer(mode, initMode) {
//            $('.quick_downs').show();
            SDLUtil.showLoadingBar(true);
            let url = `${SDLUtil.API_URL}/basis/search/searchContentsByModel.skp`;
            const param = this.getSearchParam();
            param.initMode = (initMode) ? 'Y' : '';
            return axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
//                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    console.log('LocalDB.resp.data ===> ', resp.data);
                    this.qcdnTotalCount = resp.data.rowTotalCount || 0;
                    if (resp.data.contentModels) this.qcdnLoadCount += resp.data.contentModels.rowData.length;
                    if (this.qcdnLoadCount == this.qcdnTotalCount) {
                        this.qcdnMoreMsg = SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL');
                    } else if (this.qcdnLoadCount < this.qcdnTotalCount) {
                        this.qcdnMoreMsg = SDLUtil.getMsgProp('BUTTON.SEARCH.LOAD.MORE');
                    }
                    this.setColumnHeader(resp.data, this.qcdnPage);
//                    $('.quick_downs').hide();
                    SDLUtil.showLoadingBar(false);                        
                })
                .catch(err => {
                    console.log('Error.mode ===> ', mode, err);
                    SDLUtil.errorAlert(err);
                });
        },
        viewAttachFiles(event, row) {
            $(event.target).parent('a').parent('td').parent('tr').parent('tbody').children('tr').removeClass('active');
            $(event.target).parent('a').parent('td').parent('tr').addClass('active');
            const param = { modelCode: row.BMODEL_ID };
            const url = `${SDLUtil.API_URL}/basis/search/getBomPdfFilesByModel.skp`;
            return axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
//                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    this.qcdnAttachFiles = resp.data;
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
        async initFilesLoad(knowId) {
            SDLUtil.showLoadingBar(true);
            if (SDLUtil.isNull(knowId)) {
                SDLUtil.showLoadingBar(false);
                SDLUtil.alert({
                    title: "TITLE.GLOBAL.POPUP.ALERT",  // Alert
                    msg: "MESSAGE.FILE.NOSELECTFILE",   // No file is choosed.
                    okLabel: "BUTTON.GLOBAL.CLOSE",     // Close
                    onOkEvt : () => { this.$emit('close'); }
                });
            } else {
                return await fetchAttachList({ BOARD_ID: knowId });
            }
        },
        fileDownload(ndx, data) {
            let boardId = this.columns[ndx].boardId;
            let headerNm = this.columns[ndx].headerNm;
            const param = {boardId: boardId, modelId: data.BMODEL_ID};
            const url = `${SDLUtil.API_URL}/basis/search/getKnowledgeIds.skp`;
            return axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
//                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    SDLUtil.show(
                        AttachFilePopup, {
                            title: headerNm,
                            knowledgeInfos: resp.data,
                        }, {  // component params
                            height: 'auto'
                        }   // dialog params
                    );
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
        popupBomOpen(row) {
            const url = `${SDLUtil.API_URL}/basis/search/redirectBomView.skp`;
            return axios
                .post(url, qs.stringify({ modelCode: row.BMODEL_ID }), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' }
                })
                .then(resp => {
                    SDLUtil.openLegacyWindowPopup({
                        url: resp.data,
                        title: 'SAMSUNG.COM SUPPORTED',
                        w: 850,
                        h: 720
                    });
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
        popupHtmlOpen(file) {
            SDLUtil.openLegacyWindowPopup({
                url: 'http://downloadcenter.samsung.com/content/' + file.BOM_PATH,
                title: 'SAMSUNG.COM SUPPORTED',
                w: 850,
                h: 620
            });
        },
        clickQcModel(modelCode) {
            this.modelCode = modelCode;
        },
        loadMoreSearch() {
            if (this.qcdnLoadCount < this.qcdnTotalCount) {
                this.qcdnPage += 1;
                this.isLoaded = 1;
//                SDLUtil.showLoadingBar(true);
                this.getDataFromServer(1, false); // Local DB
            } else {
                this.qcdnMoreMsg = SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL');
            }
        },
        getSearchParam() {
            const param = { 
                  keyword    : this.modelCode
                , corpNo     : $('#selectRhqSubCd').val()
                , page       : this.qcdnPage // start Page
                , perPage    : this.pageSize //
                , searchKind : 'C' // 고정
//                , relResearch   : this.relResearch
            };
            return param;
        },
        onSearch(page) {

            if (this.modelCode.trim().length < 3) {
                SDLUtil.alert('MESSAGE.SEARCH.INPUT.KWORD');
                this.$refs.kword.focus();
                return;
            }
            this.qcdnPage = 1;
            this.searchMode = '0';

//            SDLUtil.showLoadingBar(true);
//            this.isLoaded = 0;
            this.initReset();

            // 일단, 최근 검색어 등록
//            this.saveRecentModel();

            // 이단, DB 검색결과 가져오기
            this.getDataFromServer(1, true); // Local DB

            // 삼단, 검색엔진 조회
//            this.relResearch  = 'N';
//            this.sympCode     = '';
//            this.sympDesc     = '';
//            this.sympTypeCode = '';
//            this.getDataFromServer(2, initMode); // Search Engine

            return;
        },
        remakeNoDupStr(str) {
            let kWords = str.split(' ');
            let newStr = '';
            kWords.forEach(str => {
                if (newStr.indexOf(str) < 0) {
                    newStr += ' ' + str;
                } 
            });
            return newStr;
        },
        clickRelSearchWord(rel) {
            this.relResearch  = 'Y';
            this.sympCode     = rel.sympCode;
            this.sympDesc     = rel.sympDesc;
            this.sympTypeCode = rel.sympTypeCode;
            this.isLoaded = 1;
            this.initReset();
            let relWord = rel.sympDesc.replace(/\(/g, ' ').replace(/\)/g, ' ').trim();
            relWord = this.remakeNoDupStr(relWord);
            let param = {keyword: this.modelCode + relWord, searchKind: 'K'};
//            EventBus.$emit('search-reset-keyword', param);
//            this.params.searchKind = 'K';
//            this.getDataFromServer(2); // Search Engine
//            this.params.keyword = param.keyword;
        },
        changeQdnModel() {
            if (this.selModelCd) {
                this.quickDownloads.forEach(elm => {
                    if (elm.BMODEL_ID == this.selModelCd) {
                        this.selModels = elm.subValues;
                    }
                });
            } else {
                this.selModels = null;
            }
        },


        /* Exploded View */
        async searchFromServer(pageNo, mode, modelCd) {
            if (!pageNo) pageNo = 1;

            let param = {};
            let url = null;
            if (mode == 1) { // 메인 목록 조회
                param = {modelCode: this.modelCode, perPage: this.perPage, page: pageNo};
                url = `${SDLUtil.API_URL}/basis/explodedView/explodedModels.skp`;
                this.gridData = [];
            } else if (mode == 2) { // row 클릭 시 WEB/PDF 서브 조회
                param = {modelCode: modelCd, perPage: 30, page: 1};
                url = `${SDLUtil.API_URL}/basis/search/getBomPdfFilesByModel.skp`;
            }

            SDLUtil.showLoadingBar(true);
            return axios
                .post(url, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    if (mode == 1) { // search MainView
                        this.resultCount = resp.data.totalCount;
                        this.gridData = resp.data.rows;
                        console.log('this.gridData => ', this.gridData.length);

                        this.currentPage = pageNo;
                        this.gridKey += 1; // This will re-render grid
                        this.qcdnAttachFiles = [];
                    } else { // search SubView
                        console.log('resp.data ==> ', resp.data);
                        this.qcdnAttachFiles = resp.data;

                    }

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error('SEARCH ERROR =>> ', err);
                    this.searchStatus = 'error';
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        contentClick(event) {
            if (typeof event.rowKey === 'undefined') return;

            let item = this.gridData[event.rowKey];
            this.selModelCd = item.MODEL_CD;
            console.log('this.selModelCd ===> ', this.selModelCd);
            this.searchFromServer(1, 2, item.MODEL_CD);
        },
        onSearchExp(page) {
            if (this.modelCode.trim().length < 3) {
                SDLUtil.alert('MESSAGE.SEARCH.INPUT.KWORD');
                return true;
            }

            // 일단, 최근 검색어 등록
//            this.saveRecentModel();

            this.searchMode = '0';
            this.searchFromServer(page, 1);
            return;
        },
    }, // methods
    watch: { // keyword를 clearable로 지웠을 때...
        // Change of date unit
    },
    created() {
//      this.params = this.$route.query; // 검색팝업에서 받은 params
        this.params = store.getters.getPopupParams || {};
        this.modelCode = this.params.modelCode;
        this.viewName  = this.params.viewName;
    },
    mounted() {
        console.log('Mount.this.params ==> ', this.params);
        // 조회하면서 들어온다.
        if (this.viewName == 'MC') this.onSearch(1); // ModelCode Search
        else if (this.viewName == 'EM') this.onSearchExp(1); // Exploded Model Search
        else if (this.viewName == 'KN') { // KnowledgeDetail Info
            this.$router.push({
                name: 'GSPNConKnowledgeDetail',
                query: { boardId: this.params.boardId, knowledgeId: this.params.knowledgeId, type: this.viewName }
//                       , userId: this.params.userId, companyCode: this.params.companyCode }
            });
        } else alert('Wrong access.');
        return;
    },
    beforeDestroy() {
//        EventBus.$off('search-snb-reload');
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/gspnCon/CommonConnect.vue